// import { Hero } from '../components/Hero';
// import { FeaturedCategories } from '../components/FeaturedCategories';
// import { LatestListings } from '../components/LatestListings';
// import { WhyChoose } from '../components/WhyChoose';
// import { Statistics } from '../components/Statistics';
// import { Testimonials } from '../components/Testimonials';
// import { Seo } from '../components/Seo';

// export function HomePage() {
//   return (
//     <>
//       <Seo title="Buy & Sell Cars in Morocco" description="Browse, buy, and list vehicles on MORROCARS." />
//       <Hero />
//       <FeaturedCategories />
//       <LatestListings />
//       <WhyChoose />
//       <Statistics />
//       <Testimonials />
//     </>
//   );
// }
// src/pages/HomePage.jsx
import { Hero } from '../components/Hero';
import { FeaturedCategories } from '../components/FeaturedCategories';
import { WhyChoose } from '../components/WhyChoose';
import { Statistics } from '../components/Statistics';
import { Testimonials } from '../components/Testimonials';
import { Seo } from '../components/Seo';
import { useTranslation } from 'react-i18next';

export function HomePage() {
  const { t } = useTranslation('home');

  return (
    <>
      <Seo 
        title={t('hero.title')} 
        description={t('hero.description')} 
      />
      <Hero />
      <FeaturedCategories />
      <WhyChoose />
      <Statistics />
      <Testimonials />
    </>
  );
}
